import { render, staticRenderFns } from "./AddAdminUser.vue?vue&type=template&id=bf3805f0&scoped=true&"
import script from "./AddAdminUser.vue?vue&type=script&lang=js&"
export * from "./AddAdminUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3805f0",
  null
  
)

export default component.exports